export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "chipsFilters";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			this.$el.querySelectorAll("a").forEach((el) => {
				el.addEventListener("click", (e) => {
					e.preventDefault();
					history.pushState(null, null, el.getAttribute("href"));

					fetch(el.getAttribute("href"))
						.then((response) => response.text())
						.then((html) => {
							const parser = new DOMParser();
							const doc = parser.parseFromString(
								html,
								"text/html"
							);
							const $journalWrap =
								doc.querySelector(".aj-contents");
							if ($journalWrap) {
								document.querySelector(
									".aj-contents"
								).innerHTML = $journalWrap.innerHTML;
							}
						});

					let currActive = this.$el.querySelector(".active");
					if (currActive) currActive.classList.remove("active");
					el.classList.add("active");
				});
			});

			window.addEventListener("popstate", (e) => {
				if (document.querySelector(".aj-contents")) {
					fetch(window.location.href)
						.then((response) => response.text())
						.then((html) => {
							const parser = new DOMParser();
							const doc = parser.parseFromString(
								html,
								"text/html"
							);
							const $journalWrap =
								doc.querySelector(".aj-contents");
							const $navWrap =
								doc.querySelector(".landing-filters");
							if ($journalWrap) {
								document.querySelector(
									".aj-contents"
								).innerHTML = $journalWrap.innerHTML;
								document.querySelector(
									".landing-filters"
								).innerHTML = $navWrap.innerHTML;
							}
						});
				}
			});
		} else {
		}
	}
}
